import React from 'react'

const styles = {
  root: {
    background: 'url("/pdfs/bosi/page-background.jpg") 100% 100% / cover',
    width: '21cm',
    height: '29.7cm',
    display: 'flex',
    alignItems: 'center',
    margin: '-0.5cm',
    justifyContent: 'center'
  },

  page: {
    width: '16cm',
    height: '22.7cm',
    pageBreakAfter: 'always'
  }
}

const Page = ({ children }) => (
  <div id="pdfPage" wrap size="A4" style={styles.root}>
    <div style={styles.page}>{children}</div>
  </div>
)

export default Page
